// weight is in lb
export const SHEETSBOXES = [
    {
        materialId: 'D1091001',
        impresoName: 'S1',
        description: 'Shipper: Mini 7-7/8" x 4" x 2-1/4"',
        shortDescription: 'Shipper: Mini',
        weight: 0.14,
        color: '#EF5350'
    },
    {
        materialId: 'D1091002',
        impresoName: 'S2',
        description: 'Shipper: Small 7-15/16" x 7-13/16" x 4-7/16"',
        shortDescription: 'Shipper: Small',
        weight: 0.37,
        color: '#EC407A'
    },
    {
        materialId: 'D1091006',
        impresoName: 'S3',
        description: 'SHIPPER CASE: 12.25"X9.5"X2.5"',
        shortDescription: 'Shipper: Case',
        weight: 0.37,
        color: '#AB47BC'
    },
    // {
    //     materialId: 'D11300303',
    //     impresoName: 'S4',
    //     description: 'BOX: PRINTED 18 PTS 3.75" x 3.781" x 2.0625 (COAT)',
    //     shortDescription: 'Shipper: GHS',
    //     weight: 0.05,
    //     color: '#7E57C2'
    // },
    {
        materialId: 'ASC0291PR',
        impresoName: 'S4',
        description: 'Shipper: GHS',
        shortDescription: 'Shipper: GHS',
        weight: 0.52,
        color: '#58A781'
    },
    // {
    //     materialId: 'DP10917036',
    //     impresoName: 'S5',
    //     description: 'Business Card Books',
    //     shortDescription: 'Business Card Books',
    //     weight: 0.15,
    //     color: '#2E86C1'
    // },
    {
        materialId: 'D10927077',
        impresoName: 'I1',
        description: 'Shipper: Small',
        shortDescription: 'Shipper: Small',
        weight: 0.37,
        color: '#5D64C4'
    },
    {
        materialId: 'D1091007',
        impresoName: 'I2',
        description: 'Shipper: Medium',
        shortDescription: 'Shipper: Medium',
        weight: 0.60,
        color: '#5C6BC0'
    },
    {
        materialId: 'D10927017',
        impresoName: 'I3',
        description: 'Shipper: Large',
        shortDescription: 'Shipper: Large',
        weight: 0.85,
        color: '#939DD5'
    },
    {
        materialId: 'D1330005X',
        impresoName: 'E1',
        description: 'ENV:PRINTED MAILING ENV 24 PTS 25-3/4"x13 (Coat)',
        shortDescription: 'Mailing Envelope',
        weight: 0.18,
        color: '#26C6DA'
    }
    // {
    //     materialId: 'DA370ENV01',
    //     impresoName: 'E5',
    //     description: 'White Envelope for Sample packs',
    //     shortDescription: 'White Envelope for Sample',
    //     weight: .05,
    //     color: '#66BB6A'
    // },    
];

export const SHEETSBOXESPROMO = [
    {
        materialId: 'D1330006',
        impresoName: 'E2',
        description: 'ENV:SELF-SEAL ENVELOPE - WHITE, 6" X 9"',
        shortDescription: 'Self-Seal White, 6" x 9"',
        weight: 0,
        color: '#3bda26'
    },
]
export const SHEETSBOXESENVELOPE = [
    {
        materialId: 'D1330010',
        impresoName: 'E2',
        description: 'Kraft Sticker Envelope',
        shortDescription: 'Kraft Sticker Envelope',
        weight: 0.030,
        color: '#cc9900'
    },
]

export const SHEETSMATERIAL = [
    // {
    //     materialId: 'D10927077',
    //     impresoName: 'I1',
    //     description: 'Shipper',
    //     shortDescription: 'Shipper',
    //     weight: 0.37,
    //     color: '#5D64C4'
    // },
    // {
    //     materialId: 'D1091007',
    //     impresoName: 'I2',
    //     description: 'Shipper',
    //     shortDescription: 'Shipper',
    //     weight: 0.60,
    //     color: '#5C6BC0'
    // },
    // {
    //     materialId: 'D10927017',
    //     impresoName: 'I3',
    //     description: 'Shipper',
    //     shortDescription: 'Shipper',
    //     weight: 0.85,
    //     color: '#939DD5'
    // },
    {
        materialId: 'D11300700',
        impresoName: 'P1',
        description: 'Blue Box: Small',
        shortDescription: 'Blue Box: Small',
        weight: 0.048,
        color: '#939DD5'
    },
    {
        materialId: 'D11300303',
        impresoName: 'P2',
        description: 'Blue Box: Large',
        shortDescription: 'Blue Box: Large',
        weight: 0.05,
        color: '#7E57C2'
    },
    {
        materialId: 'D11300600',
        impresoName: 'P3',
        description: 'Flat Fold',
        shortDescription: 'Flat Fold',
        weight: 0.11,
        color: '#42A5F5'
    }
];

export const OABOXES = [
    {
        materialId: 'D1330005X',
        impresoName: 'E6',
        description: 'Mailing envelope',
        shortDescription: 'Mailing envelope',
        weight: 0.16,
        color: '#827717'
    },
    {
        materialId: '10916979',
        impresoName: 'S8',
        description: 'Regular Shipper 12.5"x 95" x 2.5"',
        shortDescription: 'Regular Shipper',
        weight: 0.54,
        color: '#F57F17'
    },
    {
        materialId: '10917111',
        impresoName: 'S9',
        description: 'New Shipper',
        shortDescription: 'New Shipper',
        weight: 0.66,
        color: '#BF360C'
    },
    {
        materialId: '121239',
        impresoName: 'S10',
        description: 'Large Shipper',
        shortDescription: 'Large Shipper',
        weight: 2,
        color: '#3553C7'
    }
];

export const OAMATERIAL = [
    {
        materialId: 'Y11600102',
        impresoName: 'B1',
        description: '1/4" Bocket',
        shortDescription: '1/4" Bocket',
        weight: 0.11,
        color: '#B71C1C'
    },
    {
        materialId: 'Y11600202',
        impresoName: 'B2',
        description: '0.5" Bocket',
        shortDescription: '0.5" Bocket',
        weight: 0.12,
        color: '#4A148C'
    },
    {
        materialId: 'Y11600402',
        impresoName: 'B3',
        description: '21/32" Bocket',
        shortDescription: '21/32" Bocket',
        weight: 0.14,
        color: '#1A237E'
    },
    {
        materialId: 'Y11600502',
        impresoName: 'B4',
        description: '7/8" Bocket',
        shortDescription: '7/8" Bocket',
        weight: 0.14,
        color: '#01579B'
    },
    {
        materialId: 'Y11600302',
        impresoName: 'B5',
        description: '1" Bocket',
        shortDescription: '1" Bocket',
        weight: 0.16,
        color: '#004D40'
    },
    {
        materialId: 'Y11600602',
        impresoName: 'B6',
        description: '1-13/16” Bocket',
        shortDescription: '1-13/16” Bocket',
        weight: 0.22,
        color: '#7E57C2'
    },
    {
        materialId: '10916979',
        impresoName: 'S8',
        description: 'Regular Shipper 12.5"x 95" x 2.5"',
        shortDescription: 'Regular Shipper',
        weight: 0.54,
        color: '#F57F17'
    },
    {
        materialId: '10917111',
        impresoName: 'S9',
        description: 'New Shipper',
        shortDescription: 'New Shipper',
        weight: 0.66,
        color: '#BF360C'
    },
];

export const RFIDBOXES = [
    {
        materialId      : '10927095',
        impresoName     : 'RFID 1',                                               // TBD
        description     : 'CORR:CASE 11.675 X 7.875 X 7.75 RSC 42ECT DW PLAIN',
        shortDescription: 'CORR:CASE 11.675 X 7.875 X 7.75',
        weight          : 0.16,                                                   // TBD
        color           : '#827717'                                               // TBD
    }
];

export const SAMPLE_RFIDBOXES = [
    {
        materialId      : '10927095',
        impresoName     : 'RFID 1',                                               // TBD
        description     : 'CORR:CASE 11.675 X 7.875 X 7.75 RSC 42ECT DW PLAIN',
        shortDescription: 'CORR:CASE 11.675 X 7.875 X 7.75',
        weight          : 0.16,                                                   // TBD
        color           : '#827717'                                               // TBD
    },
    {
        materialId: 'D1330005X',
        impresoName: 'E6',
        description: 'Mailing envelope',
        shortDescription: 'Mailing envelope',
        weight: 0.16,
        color: '#F57F17'
    },
];

export const RFIDMATERIAL = [
    {
        materialId      : '1122317',                                             // TBD
        impresoName     : 'RFID 2',
        description     : 'INNER CORR CARTON:CT975 FEFCO 427 32ECT E-FLT WH',
        shortDescription: 'INNER CORR CARTON:CT975',
        weight          : 0.11,                                                  // TBD
        color           : '#B71C1C'                                              // TBD
    }
];

export const SHEETSMATERIALMAP = {
    'D1091001': {
        materialId: 'D1091001',
        impresoName: 'S1',
        description: 'Shipper: Mini 7-7/8" x 4" x 2-1/4"',
        shortDescription: 'Shipper: Mini',
        weight: 0.14,
        color: '#EF5350'
    },
    'D1091002': {
        materialId: 'D1091002',
        impresoName: 'S2',
        description: 'Shipper: Small 7-15/16" x 7-13/16" x 4-7/16"',
        shortDescription: 'Shipper: Small',
        weight: 0.37,
        color: '#EC407A'
    },
    'D1091006': {
        materialId: 'D1091006',
        impresoName: 'S3',
        description: 'SHIPPER CASE: 12.25"X9.5"X2.5"',
        shortDescription: 'Shipper: Case',
        weight: 0.37,
        color: '#AB47BC'
    },
    'D11300303': {
        materialId: 'D11300303',
        impresoName: 'P2',
        description: 'Blue Box: Large',
        shortDescription: 'Blue Box: Large',
        weight: 0.05,
        color: '#7E57C2'
    },
    'D10927077': {
        materialId: 'D10927077',
        impresoName: 'I1',
        description: 'Shipper: Small',
        shortDescription: 'Shipper: Small',
        weight: 0.37,
        color: '#5D64C4'
    },
    'D1091007': {
        materialId: 'D1091007',
        impresoName: 'I2',
        description: 'Shipper: Medium',
        shortDescription: 'Shipper: Medium',
        weight: 0.60,
        color: '#5C6BC0'
    },
    // 'DP10917036': {
    //     materialId: 'DP10917036',
    //     impresoName: 'S5',
    //     description: 'Business Card Books shipper',
    //     shortDescription: 'Business Card Books',
    //     weight: 0.15,
    //     color: '#2E86C1'
    // },
    'ASC0291PR': {
        materialId: 'ASC0291PR',
        impresoName: 'S4',
        description: 'Shipper: GHS',
        shortDescription: 'Shipper: GHS',
        weight: 0.52,
        color: '#58A781'
    },
    'D11300600': {
        materialId: 'D11300600',
        impresoName: 'P3',
        description: 'Flat Fold',
        shortDescription: 'Flat Fold',
        weight: 0.11,
        color: '#42A5F5'
    },
    'DA370ENV01': {
        materialId: 'DA370ENV01',
        impresoName: 'E5',
        description: 'White Envelope for Sample packs',
        shortDescription: 'White Envelope for Sample',
        weight: .05,
        color: '#66BB6A'
    },
    'D1330012': {
        materialId: 'D1330012',
        impresoName: 'A7',
        description: 'PAPER ENVELOPE SIZE A7, 5- 1/4X7-1/4"',
        shortDescription: 'Paper Envelope Size A7',
        weight: 0.01,
        color: '#F57F17'
    },
    'DA270ENV25': {
        materialId: 'DA270ENV25',
        impresoName: 'A3',
        description: 'PAPER ENVELOPE SIZE A2, 3- 3/8 X5-3/4"',
        shortDescription: 'Paper Envelop Size A2',
        weight: 0.01,
        color: '#BF360C'
    },
    'DX2820008': {
        materialId: 'DX2820008',
        impresoName: 'STR',
        description: 'totalQty Strings (totalQty_25 packs of 25)',
        shortDescription: 'Strings pack of 25',
        weight: 0.20,
        color: '#5e4d2c'
    },
    // 'DKM73202' : {
    //     materialId: 'DKM73202',
    //     impresoName: 'STR',
    //     description: 'totalQty Strings (totalQty_25 packs of 25)',
    //     shortDescription : 'Strings pack of 25',
    //     weight: 0.20,
    //     color: '#5e4d2c'
    // },
    'DAIRBAG': {
        materialId: 'DAIRBAG',
        impresoName: 'F1',
        description: 'FILLER: AIR BAG STOROPACK 8"x8"',
        shortDescription: 'Air Bag Storopack',
        weight: 0.01,
        color: '#9CCC65'
    },
    'DNBH64403': {
        materialId: 'DNBH64403',
        impresoName: 'A1',
        description: 'POLYPROPYLENE NAME BADGE HOLDER WITH COTTON STRING',
        shortDescription: 'Name Badge Holder',
        weight: 0.22,
        color: '#004D40'
    },
    'D1330005X': {
        materialId: 'D1330005X',
        impresoName: 'E1',
        description: 'ENV:PRINTED MAILING ENV 24 PTS 25-3/4"x13 (Coat)',
        shortDescription: 'Mailing Envelope',
        weight: 0.18,
        color: '#26C6DA'
    },
    'D11300400': {
        materialId: 'D11300400',
        impresoName: 'E2',
        description: 'Flat Fold Bubble Wrap Pouch',
        shortDescription: 'Flat Fold Bubble Wrap Pouch',
        weight: 0.04,
        color: '#26A69A'
    },
    'D10927017': {
        materialId: 'D10927017',
        impresoName: 'I3',
        description: 'Shipper: Large',
        shortDescription: 'Shipper: Large',
        weight: 0.85,
        color: '#939DD5'
    },
    'D11300700': {
        materialId: 'D11300700',
        impresoName: 'P1',
        description: 'Blue Box: Small',
        shortDescription: 'Blue Box: Small',
        weight: 0.048,
        color: '#939DD5'
    },
    'D1330006': {
        materialId: 'D1330006',
        impresoName: 'E2',
        description: 'ENV:SELF-SEAL ENVELOPE - WHITE, 6" X 9"',
        shortDescription: 'Self-Seal White, 6" x 9"',
        weight: 0,
        color: '#3bda26'
    },
    'D1330010' : {
        materialId: 'D1330010',
        impresoName: 'E2',
        description: 'Kraft Sticker Envelope',
        shortDescription: 'Kraft Sticker Envelope',
        weight: 0,
        color: '#cc9900'
    },
    // {
    //     materialId: 'D10927017',
    //     impresoName: 'I3',
    //     description: 'Shipper',
    //     shortDescription: 'Shipper',
    //     weight: 0.85,
    //     color: '#5C6BC0'
    // }   
};

export const OAMATERIALMAP = {
    // TBD: 80 or 20?
    'X2820003': {
        materialId: 'X2820003',
        impresoName: 'STR',
        description: 'totalQty Strings (totalQty_80 packs of 80)',
        shortDescription: '#9-9" KNOTTED WHITE',
        weight: 0.029,                                          // What is the weight?
        color: '#5e4d2c'
    },
    'D1330005X': {
        materialId: 'D1330005X',
        impresoName: 'E6',
        description: 'Mailing Envelope',
        shortDescription: 'Mailing Envelope',
        weight: 0.16,
        color: '#827717'
    },
    '10916979': {
        materialId: '10916979',
        impresoName: 'S8',
        description: 'Regular Shipper 12.5"x 95" x 2.5"',
        shortDescription: 'Regular Shipper',
        weight: 0.54,
        color: '#F57F17'
    },
    '10917111': {
        materialId: '10917111',
        impresoName: 'S9',
        description: 'New Shipper',
        shortDescription: 'New Shipper',
        weight: 0.66,
        color: '#BF360C'
    },
    '121239': {
        materialId: '121239',
        impresoName: 'S10',
        description: 'Large Shipper',
        shortDescription: 'Large Shipper',
        weight: 2,
        color: '#3553C7'
    },
    'Y11600102': {
        materialId: 'Y11600102',
        impresoName: 'B1',
        description: '1/4" Bocket',
        shortDescription: '1/4" Bocket',
        weight: 0.11,
        color: '#B71C1C'
    },
    'Y11600202': {
        materialId: 'Y11600202',
        impresoName: 'B2',
        description: '0.5" Bocket',
        shortDescription: '0.5" Bocket',
        weight: 0.12,
        color: '#4A148C'
    },
    'Y11600402': {
        materialId: 'Y11600402',
        impresoName: 'B3',
        description: '21/32" Bocket',
        shortDescription: '21/32" Bocket',
        weight: 0.14,
        color: '#1A237E'
    },
    'Y11600502': {
        materialId: 'Y11600502',
        impresoName: 'B4',
        description: '7/8" Bocket',
        shortDescription: '7/8" Bocket',
        weight: 0.14,
        color: '#01579B'
    },
    'Y11600302': {
        materialId: 'Y11600302',
        impresoName: 'B5',
        description: '1" Bocket',
        shortDescription: '1" Bocket',
        weight: 0.16,
        color: '#004D40'
    },
    'Y11600602': {
        materialId: 'Y11600602',
        impresoName: 'B6',
        description: '1-13/16” Bocket',
        shortDescription: '1-13/16” Bocket',
        weight: 0.22,
        color: '#7E57C2'
    },
};

export const RFIDMATERIALMAP = {
    '10927095' : {
        materialId      : '10927095',
        impresoName     : 'RFID 1',                                               // TBD
        description     : 'CORR:CASE 11.675 X 7.875 X 7.75 RSC 42ECT DW PLAIN',
        shortDescription: 'CORR:CASE 11.675 X 7.875 X 7.75',
        weight          : 0.16,                                                   // TBD
        color           : '#827717'                                               // TBD
    },
    '1122317': {
        materialId      : '1122317',                                             // TBD
        impresoName     : 'RFID 2',
        description     : 'INNER CORR CARTON:CT975 FEFCO 427 32ECT E-FLT WH',
        shortDescription: 'INNER CORR CARTON:CT975',
        weight          : 0.11,                                                  // TBD
        color           : '#B71C1C'                                              // TBD
    },
    'D1330005X': {
        materialId: 'D1330005X',
        impresoName: 'E6',
        description: 'Mailing Envelope',
        shortDescription: 'Mailing Envelope',
        weight: 0.16,
        color: '#F57F17'
    },
};

export const accessoryImage = {
    accesImageContains: function (string) {
        // if(string.includes('DKM73202')) {
        //     return this['DKM73202'];
        // }
        if (string.includes('DX2820008')) {
            return this['DX2820008'];
        }
        else if (string.includes('X2820003')) {
            return this['X2820003'];
        }
        return this[string];
    },
    'DNBH64403 Bag & Lace': 'https://s3.amazonaws.com/impreso.sheet.asset/accessories/bag_lace_accessory.jpg',
    'DA270ENV25 Envelope A2': 'https://s3.amazonaws.com/impreso.sheet.asset/accessories/envelope_a2_accessory.jpg',
    // 'DKM73202' : 'https://s3.amazonaws.com/impreso.sheet.asset/accessories/strings_accessory.jpg',
    'DX2820008': 'https://s3.amazonaws.com/impreso.sheet.asset/accessories/strings_accessory.jpg',
    'X2820003': 'https://s3.amazonaws.com/impreso.sheet.asset/accessories/X2820003_strings_accessory.jpg',
    'DA270ENV25 Sobre A2': 'https://s3.amazonaws.com/impreso.sheet.asset/accessories/envelope_a2_accessory.jpg',
    'DNBH64403 Bolsa y encaje': 'https://s3.amazonaws.com/impreso.sheet.asset/accessories/bag_lace_accessory.jpg',
    // 'DKM73202 - totalQty Strings (totalQty_25 paquetes de 25)': 'https://s3.amazonaws.com/impreso.sheet.asset/accessories/bag_lace_accessory.jpg',
};

export const accessories = {
    // '727826473600030': 'DP10917036',
    // '727826473700030': 'DP10917036',
    // '727826473800030': 'DP10917036',
    // '727826473900030':  'DP10917036',

    // DNBH64403 Name Badges Bag & Lace
    '727826440300030': 'DNBH64403 Bag & Lace',
    '727826440500030': 'DNBH64403 Bag & Lace',

    // DA270ENV25 Envelope A2
    '727826435100030': 'DA270ENV25 Envelope A2',
    '727826435200030': 'DA270ENV25 Envelope A2',
    '727826435400030': 'DA270ENV25 Envelope A2',
    '727826435500030': 'DA270ENV25 Envelope A2',
    '727826435700030': 'DA270ENV25 Envelope A2',
    '727826435800030': 'DA270ENV25 Envelope A2',
    '727826436000030': 'DA270ENV25 Envelope A2',
    '727826436100030': 'DA270ENV25 Envelope A2',
    '727826447700030': 'DA270ENV25 Envelope A2',
    '727826447800030': 'DA270ENV25 Envelope A2',
    '727826448000030': 'DA270ENV25 Envelope A2',
    '727826448100030': 'DA270ENV25 Envelope A2',
    '727826448300030': 'DA270ENV25 Envelope A2',
    '727826448400030': 'DA270ENV25 Envelope A2',
    '727826448600030': 'DA270ENV25 Envelope A2',
    '727826448700030': 'DA270ENV25 Envelope A2',
    // 2019 Card Line extensions
    '727826987800030': 'DA270ENV25 Envelope A2',
    '727826987900030': 'DA270ENV25 Envelope A2',
    '727826988000030': 'DA270ENV25 Envelope A2',
    '727826988100030': 'DA270ENV25 Envelope A2',
    '727826988600030': 'DA270ENV25 Envelope A2',
    '727826988700030': 'DA270ENV25 Envelope A2',
    '727826988800030': 'DA270ENV25 Envelope A2',
    '727826988900030': 'DA270ENV25 Envelope A2',
    '727826990200030': 'DA270ENV25 Envelope A2',
    '727826990300030': 'DA270ENV25 Envelope A2',
    '727826990400030': 'DA270ENV25 Envelope A2',
    '727826990500030': 'DA270ENV25 Envelope A2',
    '727826991000030': 'DA270ENV25 Envelope A2',
    '727826991100030': 'DA270ENV25 Envelope A2',
    '727826991200030': 'DA270ENV25 Envelope A2',
    '727826991300030': 'DA270ENV25 Envelope A2',
    '727826995000030': 'DA270ENV25 Envelope A2',
    '727826995100030': 'DA270ENV25 Envelope A2',
    '727826995200030': 'DA270ENV25 Envelope A2',
    '727826995300030': 'DA270ENV25 Envelope A2',
    '727826995800030': 'DA270ENV25 Envelope A2',
    '727826995900030': 'DA270ENV25 Envelope A2',
    '727826996000030': 'DA270ENV25 Envelope A2',
    '727826996100030': 'DA270ENV25 Envelope A2',
    '727826986600030': 'DA270ENV25 Envelope A2',
    '727826986700030': 'DA270ENV25 Envelope A2',
    '727826986800030': 'DA270ENV25 Envelope A2',
    '727826986900030': 'DA270ENV25 Envelope A2',
    '727826989400030': 'DA270ENV25 Envelope A2',
    '727826989500030': 'DA270ENV25 Envelope A2',
    '727826989600030': 'DA270ENV25 Envelope A2',
    '727826989700030': 'DA270ENV25 Envelope A2',
    '727826991800030': 'DA270ENV25 Envelope A2',
    '727826991900030': 'DA270ENV25 Envelope A2',
    '727826992000030': 'DA270ENV25 Envelope A2',
    '727826992100030': 'DA270ENV25 Envelope A2',
    '727826993500030': 'DA270ENV25 Envelope A2',

    //Invitations Envelope A2
    '727826994000030': 'DA270ENV25 Envelope A2',
    '727826996900030': 'DA270ENV25 Envelope A2',
    '727826994100030': 'DA270ENV25 Envelope A2',
    '727826993700030': 'DA270ENV25 Envelope A2',
    '727826993600030': 'DA270ENV25 Envelope A2',
    '727826996800030': 'DA270ENV25 Envelope A2',
    '727826993400030': 'DA270ENV25 Envelope A2',
    '727826996700030': 'DA270ENV25 Envelope A2',
    '727826993900030': 'DA270ENV25 Envelope A2',
    '727826996600030': 'DA270ENV25 Envelope A2',
    '727826993800030': 'DA270ENV25 Envelope A2',

    // // DA770ENV25 Envelope A2
    // '727826433900030': 'DA770ENV25 Envelope A7',
    // '727826434000030': 'DA770ENV25 Envelope A7',
    // '727826434200030': 'DA770ENV25 Envelope A7',
    // '727826434300030': 'DA770ENV25 Envelope A7',
    // '727826434500030': 'DA770ENV25 Envelope A7',
    // '727826434600030': 'DA770ENV25 Envelope A7',
    // '727826434800030': 'DA770ENV25 Envelope A7',
    // '727826434900030': 'DA770ENV25 Envelope A7',
    // '727826436300030': 'DA770ENV25 Envelope A7',
    // '727826436400030': 'DA770ENV25 Envelope A7',
    // '727826436600030': 'DA770ENV25 Envelope A7',
    // '727826436700030': 'DA770ENV25 Envelope A7',
    // '727826446500030': 'DA770ENV25 Envelope A7',
    // '727826446600030': 'DA770ENV25 Envelope A7',
    // '727826446800030': 'DA770ENV25 Envelope A7',
    // '727826446900030': 'DA770ENV25 Envelope A7',
    // '727826447100030': 'DA770ENV25 Envelope A7',
    // '727826447200030': 'DA770ENV25 Envelope A7',
    // '727826447500030': 'DA770ENV25 Envelope A7',
    // '727826448900030': 'DA770ENV25 Envelope A7',
    // '727826449000030': 'DA770ENV25 Envelope A7',
    // '727826449200030': 'DA770ENV25 Envelope A7',
    // '727826449300030': 'DA770ENV25 Envelope A7',
    // // 2019 Card Line extensions
    // '727826987400030': 'DA770ENV25 Envelope A7',
    // '727826987500030': 'DA770ENV25 Envelope A7',
    // '727826987600030': 'DA770ENV25 Envelope A7',
    // '727826987700030': 'DA770ENV25 Envelope A7',
    // '727826988200030': 'DA770ENV25 Envelope A7',
    // '727826988300030': 'DA770ENV25 Envelope A7',
    // '727826988400030': 'DA770ENV25 Envelope A7',
    // '727826988500030': 'DA770ENV25 Envelope A7',
    // '727826989800030': 'DA770ENV25 Envelope A7',
    // '727826989900030': 'DA770ENV25 Envelope A7',
    // '727826990000030': 'DA770ENV25 Envelope A7',
    // '727826990100030': 'DA770ENV25 Envelope A7',
    // '727826990600030': 'DA770ENV25 Envelope A7',
    // '727826990700030': 'DA770ENV25 Envelope A7',
    // '727826990800030': 'DA770ENV25 Envelope A7',
    // '727826990900030': 'DA770ENV25 Envelope A7',
    // '727826994600030': 'DA770ENV25 Envelope A7',
    // '727826994700030': 'DA770ENV25 Envelope A7',
    // '727826994800030': 'DA770ENV25 Envelope A7',
    // '727826994900030': 'DA770ENV25 Envelope A7',
    // '727826995400030': 'DA770ENV25 Envelope A7',
    // '727826995500030': 'DA770ENV25 Envelope A7',
    // '727826995600030': 'DA770ENV25 Envelope A7',
    // '727826995700030': 'DA770ENV25 Envelope A7',
    // '727826987000030': 'DA770ENV25 Envelope A7',
    // '727826987100030': 'DA770ENV25 Envelope A7',
    // '727826987200030': 'DA770ENV25 Envelope A7',
    // '727826987300030': 'DA770ENV25 Envelope A7',
    // '727826989000030': 'DA770ENV25 Envelope A7',
    // '727826989100030': 'DA770ENV25 Envelope A7',
    // '727826989200030': 'DA770ENV25 Envelope A7',
    // '727826989300030': 'DA770ENV25 Envelope A7',
    // '727826991400030': 'DA770ENV25 Envelope A7',
    // '727826991500030': 'DA770ENV25 Envelope A7',
    // '727826991600030': 'DA770ENV25 Envelope A7',
    // '727826991700030': 'DA770ENV25 Envelope A7',

    // //Invitations Envelope A7
    // '727826996500030': 'DA770ENV25 Envelope A7',
    // '727826447400030': 'DA770ENV25 Envelope A7',
    // '727826996400030': 'DA770ENV25 Envelope A7',
    // '727826996300030': 'DA770ENV25 Envelope A7',
    // '727826996200030': 'DA770ENV25 Envelope A7',
    
    // D1330012 Envelope A7
    '727826433900030': 'D1330012 Envelope A7',
    '727826434000030': 'D1330012 Envelope A7',
    '727826434200030': 'D1330012 Envelope A7',
    '727826434300030': 'D1330012 Envelope A7',
    '727826434500030': 'D1330012 Envelope A7',
    '727826434600030': 'D1330012 Envelope A7',
    '727826434800030': 'D1330012 Envelope A7',
    '727826434900030': 'D1330012 Envelope A7',
    '727826436300030': 'D1330012 Envelope A7',
    '727826436400030': 'D1330012 Envelope A7',
    '727826436600030': 'D1330012 Envelope A7',
    '727826436700030': 'D1330012 Envelope A7',
    '727826446500030': 'D1330012 Envelope A7',
    '727826446600030': 'D1330012 Envelope A7',
    '727826446800030': 'D1330012 Envelope A7',
    '727826446900030': 'D1330012 Envelope A7',
    '727826447100030': 'D1330012 Envelope A7',
    '727826447200030': 'D1330012 Envelope A7',
    '727826447500030': 'D1330012 Envelope A7',
    '727826448900030': 'D1330012 Envelope A7',
    '727826449000030': 'D1330012 Envelope A7',
    '727826449200030': 'D1330012 Envelope A7',
    '727826449300030': 'D1330012 Envelope A7',
    // 2019 Card Line extensions
    '727826987400030': 'D1330012 Envelope A7',
    '727826987500030': 'D1330012 Envelope A7',
    '727826987600030': 'D1330012 Envelope A7',
    '727826987700030': 'D1330012 Envelope A7',
    '727826988200030': 'D1330012 Envelope A7',
    '727826988300030': 'D1330012 Envelope A7',
    '727826988400030': 'D1330012 Envelope A7',
    '727826988500030': 'D1330012 Envelope A7',
    '727826989800030': 'D1330012 Envelope A7',
    '727826989900030': 'D1330012 Envelope A7',
    '727826990000030': 'D1330012 Envelope A7',
    '727826990100030': 'D1330012 Envelope A7',
    '727826990600030': 'D1330012 Envelope A7',
    '727826990700030': 'D1330012 Envelope A7',
    '727826990800030': 'D1330012 Envelope A7',
    '727826990900030': 'D1330012 Envelope A7',
    '727826994600030': 'D1330012 Envelope A7',
    '727826994700030': 'D1330012 Envelope A7',
    '727826994800030': 'D1330012 Envelope A7',
    '727826994900030': 'D1330012 Envelope A7',
    '727826995400030': 'D1330012 Envelope A7',
    '727826995500030': 'D1330012 Envelope A7',
    '727826995600030': 'D1330012 Envelope A7',
    '727826995700030': 'D1330012 Envelope A7',
    '727826987000030': 'D1330012 Envelope A7',
    '727826987100030': 'D1330012 Envelope A7',
    '727826987200030': 'D1330012 Envelope A7',
    '727826987300030': 'D1330012 Envelope A7',
    '727826989000030': 'D1330012 Envelope A7',
    '727826989100030': 'D1330012 Envelope A7',
    '727826989200030': 'D1330012 Envelope A7',
    '727826989300030': 'D1330012 Envelope A7',
    '727826991400030': 'D1330012 Envelope A7',
    '727826991500030': 'D1330012 Envelope A7',
    '727826991600030': 'D1330012 Envelope A7',
    '727826991700030': 'D1330012 Envelope A7',

    //Invitations Envelope A7
    '727826996500030': 'D1330012 Envelope A7',
    '727826447400030': 'D1330012 Envelope A7',
    '727826996400030': 'D1330012 Envelope A7',
    '727826996300030': 'D1330012 Envelope A7',
    '727826996200030': 'D1330012 Envelope A7',

    //   //Tags
    //   '727826481700030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826482000030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826485100030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826485200030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826481800030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826482100030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826481900030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826482200030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826482300030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826482600030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826485300030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826485400030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826482400030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826482700030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826482500030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826482800030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826482900030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826483200030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826485500030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826485600030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826483000030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826483300030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826483100030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826483400030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826485800030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826485700030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826480900030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826480700030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826486200030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826486100030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826481000030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826480800030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826486000030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826485900030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826486400030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826486300030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826483700030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826483500030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826483800030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826483600030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   // 2019 Card Line extensions
    //   '727826983400030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826983500030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826983600030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826983700030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826983800030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826983900030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826984000030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826984100030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826984200030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826984300030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826984400030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826984500030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826984600030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826984700030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826984800030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826984900030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826985000030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826985100030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826985200030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826985300030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826985400030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826985500030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826985600030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826985700030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826985800030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826985900030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826986000030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826986100030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826986200030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826986300030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826986400030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',
    //   '727826986500030': 'DKM73202 - totalQty Strings (totalQty_25 packs of 25)',

    //Tags
    //  '727826481700030': 'DKM73202 - Strings',
    //  '727826482000030': 'DKM73202 - Strings',
    //  '727826485100030': 'DKM73202 - Strings',
    //  '727826485200030': 'DKM73202 - Strings',
    //  '727826481800030': 'DKM73202 - Strings',
    //  '727826482100030': 'DKM73202 - Strings',
    //  '727826481900030': 'DKM73202 - Strings',
    //  '727826482200030': 'DKM73202 - Strings',
    //  '727826482300030': 'DKM73202 - Strings',
    //  '727826482600030': 'DKM73202 - Strings',
    //  '727826485300030': 'DKM73202 - Strings',
    //  '727826485400030': 'DKM73202 - Strings',
    //  '727826482400030': 'DKM73202 - Strings',
    //  '727826482700030': 'DKM73202 - Strings',
    //  '727826482500030': 'DKM73202 - Strings',
    //  '727826482800030': 'DKM73202 - Strings',
    //  '727826482900030': 'DKM73202 - Strings',
    //  '727826483200030': 'DKM73202 - Strings',
    //  '727826485500030': 'DKM73202 - Strings',
    //  '727826485600030': 'DKM73202 - Strings',
    //  '727826483000030': 'DKM73202 - Strings',
    //  '727826483300030': 'DKM73202 - Strings',
    //  '727826483100030': 'DKM73202 - Strings',
    //  '727826483400030': 'DKM73202 - Strings',
    //  '727826485800030': 'DKM73202 - Strings',
    //  '727826485700030': 'DKM73202 - Strings',
    //  '727826480900030': 'DKM73202 - Strings',
    //  '727826480700030': 'DKM73202 - Strings',
    //  '727826486200030': 'DKM73202 - Strings',
    //  '727826486100030': 'DKM73202 - Strings',
    //  '727826481000030': 'DKM73202 - Strings',
    //  '727826480800030': 'DKM73202 - Strings',
    //  '727826486000030': 'DKM73202 - Strings',
    //  '727826485900030': 'DKM73202 - Strings',
    //  '727826486400030': 'DKM73202 - Strings',
    //  '727826486300030': 'DKM73202 - Strings',
    //  '727826483700030': 'DKM73202 - Strings',
    //  '727826483500030': 'DKM73202 - Strings',
    //  '727826483800030': 'DKM73202 - Strings',
    //  '727826483600030': 'DKM73202 - Strings',
    //  // 2019 Card Line extensi - Strings',
    //  '727826983400030': 'DKM73202 - Strings',
    //  '727826983500030': 'DKM73202 - Strings',
    //  '727826983600030': 'DKM73202 - Strings',
    //  '727826983700030': 'DKM73202 - Strings',
    //  '727826983800030': 'DKM73202 - Strings',
    //  '727826983900030': 'DKM73202 - Strings',
    //  '727826984000030': 'DKM73202 - Strings',
    //  '727826984100030': 'DKM73202 - Strings',
    //  '727826984200030': 'DKM73202 - Strings',
    //  '727826984300030': 'DKM73202 - Strings',
    //  '727826984400030': 'DKM73202 - Strings',
    //  '727826984500030': 'DKM73202 - Strings',
    //  '727826984600030': 'DKM73202 - Strings',
    //  '727826984700030': 'DKM73202 - Strings',
    //  '727826984800030': 'DKM73202 - Strings',
    //  '727826984900030': 'DKM73202 - Strings',
    //  '727826985000030': 'DKM73202 - Strings',
    //  '727826985100030': 'DKM73202 - Strings',
    //  '727826985200030': 'DKM73202 - Strings',
    //  '727826985300030': 'DKM73202 - Strings',
    //  '727826985400030': 'DKM73202 - Strings',
    //  '727826985500030': 'DKM73202 - Strings',
    //  '727826985600030': 'DKM73202 - Strings',
    //  '727826985700030': 'DKM73202 - Strings',
    //  '727826985800030': 'DKM73202 - Strings',
    //  '727826985900030': 'DKM73202 - Strings',
    //  '727826986000030': 'DKM73202 - Strings',
    //  '727826986100030': 'DKM73202 - Strings',
    //  '727826986200030': 'DKM73202 - Strings',
    //  '727826986300030': 'DKM73202 - Strings',
    //  '727826986400030': 'DKM73202 - Strings',
    //  '727826986500030': 'DKM73202 - Strings',

    '727826481700030': 'DX2820008 - Strings',
    '727826482000030': 'DX2820008 - Strings',
    '727826485100030': 'DX2820008 - Strings',
    '727826485200030': 'DX2820008 - Strings',
    '727826481800030': 'DX2820008 - Strings',
    '727826482100030': 'DX2820008 - Strings',
    '727826481900030': 'DX2820008 - Strings',
    '727826482200030': 'DX2820008 - Strings',
    '727826482300030': 'DX2820008 - Strings',
    '727826482600030': 'DX2820008 - Strings',
    '727826485300030': 'DX2820008 - Strings',
    '727826485400030': 'DX2820008 - Strings',
    '727826482400030': 'DX2820008 - Strings',
    '727826482700030': 'DX2820008 - Strings',
    '727826482500030': 'DX2820008 - Strings',
    '727826482800030': 'DX2820008 - Strings',
    '727826482900030': 'DX2820008 - Strings',
    '727826483200030': 'DX2820008 - Strings',
    '727826485500030': 'DX2820008 - Strings',
    '727826485600030': 'DX2820008 - Strings',
    '727826483000030': 'DX2820008 - Strings',
    '727826483300030': 'DX2820008 - Strings',
    '727826483100030': 'DX2820008 - Strings',
    '727826483400030': 'DX2820008 - Strings',
    '727826485800030': 'DX2820008 - Strings',
    '727826485700030': 'DX2820008 - Strings',
    '727826480900030': 'DX2820008 - Strings',
    '727826480700030': 'DX2820008 - Strings',
    '727826486200030': 'DX2820008 - Strings',
    '727826486100030': 'DX2820008 - Strings',
    '727826481000030': 'DX2820008 - Strings',
    '727826480800030': 'DX2820008 - Strings',
    '727826486000030': 'DX2820008 - Strings',
    '727826485900030': 'DX2820008 - Strings',
    '727826486400030': 'DX2820008 - Strings',
    '727826486300030': 'DX2820008 - Strings',
    '727826483700030': 'DX2820008 - Strings',
    '727826483500030': 'DX2820008 - Strings',
    '727826483800030': 'DX2820008 - Strings',
    '727826483600030': 'DX2820008 - Strings',
    // 2019 Card Line extensi - Strings',
    '727826983400030': 'DX2820008 - Strings',
    '727826983500030': 'DX2820008 - Strings',
    '727826983600030': 'DX2820008 - Strings',
    '727826983700030': 'DX2820008 - Strings',
    '727826983800030': 'DX2820008 - Strings',
    '727826983900030': 'DX2820008 - Strings',
    '727826984000030': 'DX2820008 - Strings',
    '727826984100030': 'DX2820008 - Strings',
    '727826984200030': 'DX2820008 - Strings',
    '727826984300030': 'DX2820008 - Strings',
    '727826984400030': 'DX2820008 - Strings',
    '727826984500030': 'DX2820008 - Strings',
    '727826984600030': 'DX2820008 - Strings',
    '727826984700030': 'DX2820008 - Strings',
    '727826984800030': 'DX2820008 - Strings',
    '727826984900030': 'DX2820008 - Strings',
    '727826985000030': 'DX2820008 - Strings',
    '727826985100030': 'DX2820008 - Strings',
    '727826985200030': 'DX2820008 - Strings',
    '727826985300030': 'DX2820008 - Strings',
    '727826985400030': 'DX2820008 - Strings',
    '727826985500030': 'DX2820008 - Strings',
    '727826985600030': 'DX2820008 - Strings',
    '727826985700030': 'DX2820008 - Strings',
    '727826985800030': 'DX2820008 - Strings',
    '727826985900030': 'DX2820008 - Strings',
    '727826986000030': 'DX2820008 - Strings',
    '727826986100030': 'DX2820008 - Strings',
    '727826986200030': 'DX2820008 - Strings',
    '727826986300030': 'DX2820008 - Strings',
    '727826986400030': 'DX2820008 - Strings',
    '727826986500030': 'DX2820008 - Strings',

    //22 Stickers for 2$ Promo
    '727827667800030': 'Self-Seal White, 6" x 9"',
    '727827667900030': 'Self-Seal White, 6" x 9"',
    '727827668000030': 'Self-Seal White, 6" x 9"',
    '727827668100030': 'Self-Seal White, 6" x 9"',

    // New type of strings (not the ones with clasps used in WePrint)
    '727827792805000-e': 'X2820003 - STRING: #9-9" KNOTTED WHITE (80) STRING BAGS',
    '727827792805000': 'X2820003 - STRING: #9-9" KNOTTED WHITE (80) STRING BAGS',

    //Phase 2 tags -- **** No strings needed for these tag products ****
    //  '727822781105000'  : 'X2820003 - STRING: #9-9" KNOTTED WHITE (80) STRING BAGS',
    //  '727822781105000-e': 'X2820003 - STRING: #9-9" KNOTTED WHITE (80) STRING BAGS',
    //  '727822781205000'  : 'X2820003 - STRING: #9-9" KNOTTED WHITE (80) STRING BAGS',
    //  '727822781205000-e': 'X2820003 - STRING: #9-9" KNOTTED WHITE (80) STRING BAGS',
    //  '727822781305000'  : 'X2820003 - STRING: #9-9" KNOTTED WHITE (80) STRING BAGS',
    //  '727822781305000-e': 'X2820003 - STRING: #9-9" KNOTTED WHITE (80) STRING BAGS',
};

//Make To Order Products (contains both card & tag skus)
export const MTO_CARDS_PRODUCTSKU = [
    //Phase 1
    '727827792605000',  //Cards
    '727827792705000',  //Cards
    '727827792805000',  //Tags
    '727827792605000-e',  //Cards
    '727827792705000-e',  //Cards
    '727827792805000-e',  //Tags

    //Phase 2
    '727822780505000',
    '727822780505000-e',
    '727822780605000',
    '727822780605000-e',
    '727822780705000',
    '727822780705000-e',
    '727822780805000',
    '727822780805000-e',
    '727822780905000',
    '727822780905000-e',
    '727822781005000',
    '727822781005000-e',
    '727822781105000',  //Tags
    '727822781105000-e',  //Tags
    '727822781205000',  //Tags
    '727822781205000-e',  //Tags
    '727822781305000',  //Tags
    '727822781305000-e',  //Tags

    '727827795005000',                     //new tag sku
    '727827795005000-e'  //new tag sku
];

export const MTO_PRODUCTSKU = {
    tags: [
        //Phase 1
        '727827792805000',
        '727827792805000-e',

        //Phase 2
        '727822781105000',
        '727822781105000-e',
        '727822781205000',
        '727822781205000-e',
        '727822781305000',
        '727822781305000-e',
        '727827795005000',  //new tag sku
        '727827795005000-e',  //new tag sku

        '727827795705000', //new tag sku
        '727827795705000-e', //new tag sku
    ],

    cards: [
        //Phase 1
        '727827792605000',
        '727827792705000',
        '727827792605000-e',
        '727827792705000-e',

        //Phase 2
        '727822780505000',
        '727822780505000-e',
        '727822780605000',
        '727822780605000-e',
        '727822780705000',
        '727822780705000-e',
        '727822780805000',
        '727822780805000-e',
        '727822780905000',
        '727822780905000-e',
        '727822781005000',
        '727822781005000-e',

        '727827795605000',
        '727827795605000-e',
        '727827795505000',
        '727827795505000-e'
    ]
};

//Contains only tags
export const MTO_TAGS = [
    //Phase 1
    '727827792805000',
    '727827792805000-e',

    //Phase 2
    '727822781105000',
    '727822781105000-e',
    '727822781205000',
    '727822781205000-e',
    '727822781305000',
    '727822781305000-e',

    '727827795005000',                     //new tag sku
    '727827795005000-e'  //new tag sku
];

//Phase 2 MTO Tag products -- WITHOUT STRINGS
export const MTO_TAGS_SKU_PHASE2 = [
    '727822781105000',
    '727822781105000-e',
    '727822781205000',
    '727822781205000-e',
    '727822781305000',
    '727822781305000-e',
];

//Contains only cards
export const MTO_CARDS = [
    //Phase 1
    '727827792605000',  //Cards
    '727827792705000',  //Cards
    '727827792605000-e',  //Cards
    '727827792705000-e',  //Cards

    //Phase 2
    '727822780505000',
    '727822780505000-e',
    '727822780605000',
    '727822780605000-e',
    '727822780705000',
    '727822780705000-e',
    '727822780805000',
    '727822780805000-e',
    '727822780905000',
    '727822780905000-e',
    '727822781005000',
    '727822781005000-e',
];


export const MTO_MATERIAL: any = [
    // {
    //     materialId: 'D1330005X',
    //     impresoName: 'E1',
    //     description: 'ENV:PRINTED MAILING ENV 24 PTS 25-3/4"x13 (Coat)',
    //     shortDescription: 'Mailing Envelope',
    //     weight: 0.18,
    //     color: '#26C6DA'
    // },
    // {
    //     materialId: 'X2820003',
    //     impresoName: 'STR',
    //     description: 'totalQty Strings (totalQty_80 packs of 80)',
    //     shortDescription : '#9-9" KNOTTED WHITE',
    //     weight: 0.029, // What is the weight?
    //     color: '#5e4d2c'
    // },
    {
        materialId: 'Y11600102',
        impresoName: 'B1',
        description: '1/4" Bocket',
        shortDescription: '1/4" Bocket',
        weight: 0.11,
        color: '#B71C1C'
    },
    {
        materialId: 'Y11600402',
        impresoName: 'B3',
        description: '21/32" Bocket',
        shortDescription: '21/32" Bocket',
        weight: 0.14,
        color: '#1A237E'
    },
];


export const PTO_PRODUCTSKU = {
    labels: [
        '727827794305000-e',
        '727827794305000',
        '727827794505000-e',
        '727827794505000'
    ],

    tags: [
        '727827794805000-e',
        '727827794805000'
    ],

    name_tags: [
        '727827794605000-e',
        '727827794605000',
    ],

    cards: [
        '727827794705000-e',
        '727827794705000',
        '727827794905000-e',
        '727827794905000'
    ]
};

//For Single Job PTO orders ONLY --- (multi job orders are operator choice)
export const PTO_BOXES: any = [
    {
        materialId: 'D1330005X',
        impresoName: 'E6',
        description: 'Mailing envelope',
        shortDescription: 'Mailing envelope',
        weight: 0.16,
        color: '#827717'
    },
];
export const PTO_MATERIAL: any = [
    {
        materialId: 'Y11600102',
        impresoName: 'B1',
        description: '1/4" Bocket',
        shortDescription: '1/4" Bocket',
        weight: 0.11,
        color: '#B71C1C'
    },
];


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/ngrx/material-type.ts